import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '../api/apiClient';
import { Categoria, NuevaCategoria } from '../types/catalogo';

export function useCategorias() {
  return useQuery({
    queryKey: ['categorias'],
    queryFn: () => apiFetch<Categoria[]>('/categorias'),
  });
}

export function useCrearCategoria() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (datos: NuevaCategoria) =>
      apiFetch<Categoria>('/categorias', { method: 'POST', body: datos, autenticado: true }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['categorias'] }),
  });
}

/** BR-CAT-08: el backend rechaza con 400 si la categoria tiene productos asociados —
 * el mensaje llega en el error y se muestra tal cual (FR-ERR-01). */
export function useEliminarCategoria() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      apiFetch<void>(`/categorias/${id}`, { method: 'DELETE', autenticado: true }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['categorias'] }),
  });
}
